import { createFileRoute } from "@tanstack/react-router";
import { CreateExpeditionPage } from "@/features/ventes/components/expeditions/CreateExpeditionPage";

export const Route = createFileRoute("/_app/ventes/expeditions/create")({
  staticData: {
    title: "Nouvelle expédition",
    showInBreadcrumb: true,
  },
  component: CreateExpeditionPage,
});
